import { render, staticRenderFns } from "./IsMarried.vue?vue&type=template&id=5130789f&"
import script from "./IsMarried.vue?vue&type=script&lang=js&"
export * from "./IsMarried.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports